import React from 'react';
import { NewModal } from 'lib/components';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button, Typography } from 'react-covideo-common';
import { useDeletePronunciationMutation } from 'lib/api/pronunciations/useDeletePronunciationMutation';
import { IPronunciation } from 'lib/api/pronunciations/useQueryPronunciations';
import { Trans, useTranslation } from 'react-i18next';

interface DeletePronunciationModalProps {
  pronunciation: IPronunciation;
  onClose: () => void;
}

export const DeletePronunciationModal = ({
  pronunciation,
  onClose,
}: DeletePronunciationModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: deletePronunciationMutation, isLoading: isDeleting } =
    useDeletePronunciationMutation(onClose);

  const onDelete = () => {
    deletePronunciationMutation({ id: pronunciation.id });
  };

  return (
    <NewModal
      headerText={t('Delete Pronunciation')}
      closeModal={onClose}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Flex flexDirection='column' gap='20px'>
        <Typography>
          <Trans
            i18nKey='pronunciationDeleteConfirmation'
            values={{ text: pronunciation.text }}
          />
        </Typography>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text={t('Cancel')}
            onClick={onClose}
            variant='secondary'
            disabled={isDeleting}
          />
          <Button
            text={t('Delete')}
            onClick={onDelete}
            variant='destructive'
            loading={isDeleting}
            disabled={isDeleting}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};
